var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"column":""}},[_c('RolesTable',{ref:"rolesTable"}),_c('AddDeleteButtons',{attrs:{"selected":_vm.selected,"add-icon":"user-plus","remove-icon":"user-minus","buttons-text":_vm.$t('roles.role')},on:{"create":_vm.onCreateClick,"confirm-remove":_vm.onRemoveConfirmed}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }